import type { FaireProductEntity } from "../../entity_types/product";

export const p_xjrqhrrw77: FaireProductEntity = {
  token: "p_xjrqhrrw77",
  type: "product",
  name: "Rap Snacks Oowee Neon Worms (5.3oz) (12-Pack)",
  brandToken: "b_qvgnvkj5hp",
  brandName: "AI Distribution",
  imageUrl: "https://cdn.faire.com/fastly/fba80b02059b5bf3d17045a6e93334ac65130781ded9792a11553cca7a4fccbf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31b02f6c08fd42d66d21bbb4c0589f02ccd66dbf55e8bdb15669a76fe8d5dedf.png"
  ],
  priceDollars: 23.54,
  description: "Rap Snacks Oowee Neon Worms come in a convenient 5.3 oz bag, with a 12-pack ensuring you have plenty to enjoy or share. These gummy worms stand out with their vibrant neon colors and a perfect balance of sweet and tangy flavors. Their chewy texture provides a satisfying bite, making them an excellent choice for both casual snacking and party treats. Crafted to maintain consistent quality across every bag, these gummies appeal to candy enthusiasts of all ages who appreciate a fun, flavorful, and visually striking candy experience.\n\n(12) Pack – Oowee Neon Worms, 5.3oz each.",
  tags: [],
  msrpDollars: 47.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:53.578Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
